// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2ZgEI","left":"StickyBox_left__251Pa","right":"StickyBox_right__XaTEG"};